const API_BASE_URL = 'https://bctestnetfaucet.xpxsirius.io'
const API_URL = 'https://bctestnetfaucet.xpxsirius.io/api'

export default {
  API_BASE_URL,
  API_URL
}
